import React from "react";
import { ActionButton, TooltipHost, useDisclosure } from "sprint-common-web";

import { AuthorizationWrapper } from "../../../../core/security/AuthorizationWrapper";
import { SprintAccessRight } from "../../../../core/security/SprintAccessRight";
import { OrderStatus } from "../../../common/types/OrderStatus";
import { canCopyOrderOutputs, CopyOrderOutputsDialog } from "../../copy-outputs/CopyOrderOutputsDialog";

export interface CopyOrderOutputsButtonProps {
    status: OrderStatus;
    orderId: string;
}

export const CopyOrderOutputsButton: React.VFC<CopyOrderOutputsButtonProps> = ({
    status,
    orderId
}: CopyOrderOutputsButtonProps) => {
    const { isOpen, onOpen, onClose } = useDisclosure();

    return (
        <AuthorizationWrapper accessRights={[SprintAccessRight.OrdReadWrite]}>
            <TooltipHost content="Copy outputs" styles={{ root: { display: "inline-block" } }}>
                <ActionButton
                    key={orderId}
                    iconProps={{ iconName: "QuickNote" }}
                    disabled={!canCopyOrderOutputs(status)}
                    onClick={onOpen}
                />
            </TooltipHost>
            <CopyOrderOutputsDialog orderId={orderId} isOpen={isOpen} onClose={onClose}></CopyOrderOutputsDialog>
        </AuthorizationWrapper>
    );
};
